import { LOAD_SUBMISSION_TYPES } from '../actionTypes';

const initialState = {
  submissionTypes: [],
};

const utilities = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_SUBMISSION_TYPES: {
      return { ...state, submissionTypes: action.payload };
    }
    default: {
      return state;
    }
  }
};

export default utilities;



// WEBPACK FOOTER //
// ./src/redux/reducers/utilities.js